import { IsNotEmpty, IsString, IsUUID } from 'class-validator';

export class CreateCountrySubdivisionDto {
  @IsString()
  @IsNotEmpty()
  name: string;

  @IsString()
  @IsNotEmpty()
  code: string;

  @IsUUID('4')
  @IsNotEmpty()
  countryId: string;
}
